import { useLocalization } from '@/shared/i18n'
import type { SurveyPipeline, SurveyState } from '@/shared/api/queries'
import { Alert, Button, Card, ErrorDetails, Icon, Stack, Stage, Text } from '@/shared/ui'

import { ReadingScan } from './ReadingScan'
import type { Reading } from './reading'

export function ReadingScreen({
  state,
  pipeline,
  reading,
  busy,
  onBack,
}: {
  state: SurveyState
  pipeline: SurveyPipeline
  reading: Reading
  busy: boolean
  onBack: () => void
}) {
  const { t } = useLocalization()
  const { pending, error, lost } = reading

  return (
    <Stage
      top
      footer={
        <>
          {error ? (
            <Alert status="danger" title={t('survey.pipeline.failed')}>
              <Stack gap="xs">
                <Text role="body">{error.message}</Text>
                <ErrorDetails error={error} />
              </Stack>
            </Alert>
          ) : null}
          {lost ? <Alert status="warning" title={t('survey.pipeline.lost')} /> : null}
          {lost ? null : (
            <Button full disabled={pending || busy} onClick={() => reading.read(pipeline)}>
              {pending
                ? t('survey.pipeline.reading')
                : error
                  ? t('survey.pipeline.retry')
                  : t('survey.pipeline.start')}
            </Button>
          )}
          <Button
            variant={lost ? 'primary' : 'quiet'}
            full
            disabled={pending || busy}
            onClick={onBack}
          >
            {t('survey.pipeline.retake')}
          </Button>
        </>
      }
    >
      <Stack gap="sm" className="ask__head">
        <Text role="eyebrow" tone="muted">
          {state.title}
        </Text>
        <Text as="h1" role="heading-2">
          {pending ? t('survey.pipeline.reading') : t('survey.pipeline.start')}
        </Text>
      </Stack>
      <ReadingScan active={pending} />
      <Card>
        <Stack direction="row" gap="sm">
          <Icon size="lg">🔒</Icon>
          <Text role="caption" tone="muted" measure>
            {t('survey.pipeline.reading.body')}
          </Text>
        </Stack>
      </Card>
    </Stage>
  )
}
